import { createAsyncThunk } from "@reduxjs/toolkit";
import PackagesApiService from "../../infrastructure/api/packages";
import { setMessage } from "../slices/message";

// Get Active Packages
export const fetchActivePackages = createAsyncThunk(
  "packages/fetchActive",
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const response = await PackagesApiService.getActivePackages(params);
      return response;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "خطا در دریافت لیست پکیج‌ها";
      dispatch(setMessage(message));
      return rejectWithValue(message);
    }
  }
);

// Get Package Details
export const fetchPackageDetails = createAsyncThunk(
  "packages/fetchDetails",
  async (packageId, { dispatch, rejectWithValue }) => {
    try {
      const response = await PackagesApiService.getPackageDetails(packageId);
      return response;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "خطا در دریافت جزئیات پکیج";
      dispatch(setMessage(message));
      return rejectWithValue(message);
    }
  }
);

// Search Packages
export const searchPackages = createAsyncThunk(
  "packages/search",
  async (searchParams, { dispatch, rejectWithValue }) => {
    try {
      const response = await PackagesApiService.searchPackages(searchParams);
      return response;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "خطا در جستجوی پکیج‌ها";
      dispatch(setMessage(message));
      return rejectWithValue(message);
    }
  }
);

// Compare Packages
export const comparePackages = createAsyncThunk(
  "packages/compare",
  async (packageIds, { dispatch, rejectWithValue }) => {
    try {
      const response = await PackagesApiService.comparePackages(packageIds);
      return response;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "خطا در مقایسه پکیج‌ها";
      dispatch(setMessage(message));
      return rejectWithValue(message);
    }
  }
);

// Get Contractor Packages
export const fetchContractorPackages = createAsyncThunk(
  "packages/fetchContractorPackages",
  async (contractorId, { dispatch, rejectWithValue }) => {
    try {
      const response = await PackagesApiService.getContractorPackages(
        contractorId
      );
      return response;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "خطا در دریافت پکیج‌های پیمانکار";
      dispatch(setMessage(message));
      return rejectWithValue(message);
    }
  }
);
